import styled from 'styled-components'

const StyledSubTitleBlock = styled.div`
  margin-bottom: 1.5rem;
`

const StyledTitle = styled.h2`
  margin: 0;
  color: #4b4b4b;
  font-size: 1.5rem;
  font-weight: normal;
`

const StyledDescription = styled.p`
  margin: 0.3rem 0 0 0;
  color: grey;
`

type SubTitleProps = {
  title: string
  description?: string
  className?: string
}

function SubTitle({ title, description, className }: SubTitleProps) {
  return (
    <StyledSubTitleBlock className={className}>
      <StyledTitle>{title}</StyledTitle>
      {description && <StyledDescription>{description}</StyledDescription>}
    </StyledSubTitleBlock>
  )
}

export default SubTitle
